export default __webpack_public_path__ + "static/media/houimg3.67ac7a61.webp";